const BRIDGE_COURSE_DEEPLINK_TEMPLATE =
  "/dashboard?module=subscriptions&type=review&isFromDeepLinking=true&packageid=2012&grade=9&examname=1017&examId=1017&page=foundation-course-for-class-9";

/** Static deeplink with `grade`, `packageid`, and exam replaced from the logged-in user. */
export function buildBridgeCourseDeeplink(
  grade: number | string,
  packageId: string,
  examId?: number | string | null,
): string {
  const url = new URL(BRIDGE_COURSE_DEEPLINK_TEMPLATE, window.location.origin);
  url.searchParams.set("grade", String(grade));
  url.searchParams.set("packageid", packageId);
  if (examId != null && String(examId) !== "") {
    url.searchParams.set("examname", String(examId));
    url.searchParams.set("examId", String(examId));
  }
  return `${url.pathname}?${url.searchParams.toString()}`;
}

/** Direct subscriptions review URL — skips the dashboard deeplink hop. */
export function buildBridgeCourseSubscriptionsPath(
  grade: number | string,
  packageId: string,
  examId?: number | string | null,
): string {
  const url = new URL(BRIDGE_COURSE_DEEPLINK_TEMPLATE, window.location.origin);
  url.searchParams.set("grade", String(grade));
  url.searchParams.set("packageid", packageId);
  if (examId != null && String(examId) !== "") {
    url.searchParams.set("examname", String(examId));
    url.searchParams.set("examId", String(examId));
  }
  url.searchParams.delete("module");
  url.searchParams.delete("isFromDeepLinking");
  return `/subscriptions?${url.searchParams.toString()}`;
}
